import * as Models from '@models';
import { BitfFormItemConfig } from '@models';

export const modelsMap = new Map<string, any>([
  ['users', Models.User],
  ['splist/calendar-events', Models.EventCalendarAdapter],
  ['splist/event-category', Models.EventCategoryAdapter],
  ['splist/colors', Models.ColorAdapter],
  ['splist/news', Models.NewsAdapter],
  ['spdocs/document-archive', Models.FsItemAdapter],
  ['form-items-config', Models.BitfFormItemConfig],
  ['splist/tags', Models.Tag],
  ['spsearch', Models.FsItem],
  ['coupons', Models.UserCoupon],
  ['coupons/threshold', Models.UserCouponThreshold],
  ['coupons/download', Models.FileExport],
]);
